import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { usersScreen } from '@/ui/pages/Users/usersScreen';

/** HS-869: the list is a `@smartsash/data-screen` definition — see `groups.index.tsx`. */
const UsersListScreen = usersScreen.ListScreen;

export const Route = createFileRoute('/_dashboard/users/')({
  validateSearch: usersScreen.validateSearch,
  loaderDeps: usersScreen.loaderDeps,
  beforeLoad: requireRoute('/users'),
  loader: usersScreen.loaderFor(),
  component: UsersListScreen,
});
